<template>
  <div class="details">
    <div class="nuv">
      <a href="/tjkStudy/examlist" class="active">考试中心</a>&gt;<span>{{ data.examConfig.name }}</span>
    </div>
    <div class="box">
      <div class="left">
        <div class="details-box clear">
          <div :style="style(data.examConfig.iconUrl)" class="zoomImage"></div>
          <div class="txt">
            <h2>{{ data.examConfig.name }}</h2>
            <template v-if="data.examConfig.examType == 'Formal'">
              <div class="iconfont icon-people">
                <span v-if="data.examStastics != null">已有<i>{{ data.examStastics.registerNum }}</i>人报名</span>
                <span v-else>已有<i>0</i>人报名</span>
              </div>
              <p>报名时间：{{ data.examConfig.regStartTime }} ~ {{ data.examConfig.regEndTime }}</p>
            </template>
            <p>考试时间：{{ data.examConfig.startTime }} ~ {{ data.examConfig.endTime }}</p>
            <p>
              <template v-if="data.examPaper.paperType == 'Normal'">
                <span class="pr">总分：{{ data.examPaper.totalScore }}分</span>
              </template>
              <span>及格：{{ data.examConfig.passScore }}<template v-if="data.examPaper.paperType == 'Normal'">分</template><template v-else="data.examPaper.paperType == 'Typing'">字/分</template></span>
            </p>
            <p v-if="data.highestScoreRecord != null">
              我的最高纪录：{{ data.highestScoreRecord.score }}<template v-if="data.examPaper.paperType == 'Normal'">分</template><template v-else="data.examPaper.paperType == 'Typing'">字/分</template>(<template v-if="data.highestScoreRecord.isPassed =='passed'">通过</template><template v-else>未通过</template>)
            </p>
            <div class="join" v-if="data.examState == 'WaitingRegister'">报名未开始</div>
            <div class="join" v-else-if="data.examState == 'WaitingCheckState'">已报名，等待审核</div>
            <div class="join" v-else-if="data.examState == 'GoRegister'" @click="toRegister(data.examConfigId)">立即报名</div>
            <div class="join" v-else-if="data.examState == 'UnRegister'">报名已结束</div>
            <div class="join" v-else-if="data.examState == 'WaitingExam'">{{ data.examTypeName }}未开始</div>
	          <div class="join" v-else-if="data.examState == 'GoExam'">
              <template v-if="data.examPaper.paperType == 'Normal'">
                <router-link :to="{name: 'exam', params: {id: data.examConfigId}}">开始{{ data.examTypeName }}</router-link>
              </template>
              <template v-else="data.examPaper.paperType == 'Typing'">
                <router-link :to="{name: 'examTyping', params: {id: data.examConfigId}}">开始{{ data.examTypeName }}</router-link>
              </template>
            </div>
            <div class="join" v-else-if="data.examState == 'KeppingExam'">
              <template v-if="data.examPaper.paperType == 'Normal'">
                <router-link :to="{name: 'exam', params: {id: data.examConfigId}}">继续{{ data.examTypeName }}</router-link>
              </template>
              <template v-else="data.examPaper.paperType == 'Typing'">
                <router-link :to="{name: 'examTyping', params: {id: data.examConfigId}}">继续{{ data.examTypeName }}</router-link>
              </template>
            </div>
            <div class="join refuse" v-else-if="data.examState == 'WaitingReExam'">{{ data.hint }}</div>
            <div class="join" v-else-if="data.examState == 'GoReExam'">
              <template v-if="data.examPaper.paperType == 'Normal'">
                <router-link :to="{name: 'exam', params: {id: data.examConfigId}}">重新{{ data.examTypeName }}</router-link>
              </template>
              <template v-else="data.examPaper.paperType == 'Typing'">
                <router-link :to="{name: 'examTyping', params: {id: data.examConfigId}}">重新{{ data.examTypeName }}</router-link>
              </template>
            </div>
            <div class="join" v-else-if="data.examState == 'Examed'">{{ data.examTypeName }}完毕</div>
            <div class="join" v-else-if="data.examState == 'OutDateExam'">{{ data.examTypeName }}已结束</div>
            <div class="join refuse" v-else-if="data.examState == 'CheckStateUnPassed'">
              <p>审核申请被拒绝，{{ data.hint }}</p>
            </div>
            <div class="join refuse" v-else-if="data.examState == 'UnableRegister'">
              <template v-if="!!data.prerequisiteTodo">
                <p v-if="data.prerequisiteTodo.todoTypeName == 'Course'">
                  先去参加<a :href="getCourseUrl(data.prerequisiteTodo.todoId)" target="_blank">{{ data.prerequisiteTodo.todoName }}</a>课程再来报名吧
                </p>
                <p v-else-if="data.prerequisiteTodo.todoTypeName == 'ExamConfig'">
                  先去参加<a :href="getExamUrl(data.prerequisiteTodo.todoId)" target="_blank">{{ data.prerequisiteTodo.todoName }}</a>考试再来报名吧
                </p>
              </template>
              <template v-else>
                <p>暂时不能报名该场考试，由于需要先参加的考试或课程正在上架中，请耐心等待或联系培训老师</p>
              </template>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="cat-head">
            <a href="#present" class="active">考试详情</a>
            <a href="#catalog">考试须知</a>
          </div>
          <div class="present" id="present">
            <ul>
              <template v-if="data.examPaper.paperType == 'Normal'">
                <li>考试总分：{{ data.examPaper.totalScore }}分</li>
              </template>
              <li>及格分数：{{ data.examConfig.passScore }}<template v-if="data.examPaper.paperType == 'Normal'">分</template><template v-else="data.examPaper.paperType == 'Typing'">字/分</template></li>
              <template v-if="data.examConfig.maxExamTimes > 1">
                <li>最高可考次数：{{ data.examConfig.maxExamTimes }}次</li>
                <li>考试间隔：{{ data.examConfig.eachExamIntervalHours }}小时</li>
              </template>
              <li>考试时长：{{ data.examConfig.duration }}分钟</li>
              <li v-if="data.examConfig.examType == 'Formal'">考试类型：正式考试</li>
              <li v-else="data.examConfig.examType == 'Practice'">考试类型：模拟练习</li>
            </ul>
          </div>
          <a href="javascript:;" class="top-head">考试须知</a>
          <div class="catalog" id="catalog">
            <p v-if="data.examConfig.description != ''" v-html="data.examConfig.description"></p>
            <p v-else>暂无信息</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        'success': true,
        'message': '',
        'id': this.$route.params.id,
        'data': {
          examConfigId: '',
          examConfig: {
            name: '',
            iconUrl: '',
            passScore: '',
            description: '',
            examType: '',
            regStartTime: '',
            regEndTime: '',
            startTime: '',
            endTime: '',
            duration: '',
          },
          examPaper:{
            totalScore: ''
          },
          examState: '',
          examStastics: {
            registerNum: ''
          },
          examTypeName: ''
        }
      }
    },
    mounted: function() {
      this.getList()
    },
    methods: {
      getList() {
        var data = {
          'examConfigId': this.id
        }
        this.$http.post(API_ROOT.system + '/tjkExam/examDetail', data).then(response => {
          var result = response.data
          this.success = result.success
          this.message = result.msg
          if (result.success) {
            this.data = result.data
            if(result.data.examConfig.examType == 'Formal') {
              this.data.examTypeName='考试'
            }else if(result.data.examConfig.examType == 'Practice') {
              this.data.examTypeName='练习'
            }
          }else {
            alert(result.msg)
          }
        }, response => {
          alert('网络繁忙，请稍后重试！')
        })
      },
      toRegister(examConfigId) {
        var data = {
          'examConfigId': this.id
        }
        this.$http.post(API_ROOT.system + '/examRecord/registerExam', data).then(response => {
          var result = response.data
          this.success = result.success
          this.message = result.msg
          if (result.success) {
            this.$message({
              message: '已报名',
              type: 'success',
              center: true,
              duration: 1000
            })
            this.getList()
          }else {
            alert(result.msg)
          }
        }, response => {
          alert('网络繁忙，请稍后重试！')
        })
      },
      //设置封面图片
      style(iconUrl) {
        return {
          backgroundImage: 'url(' + iconUrl + ')'
        }
      },
      //编码超链接地址
      getCourseUrl(id) {
        var a ='/tjkStudy/courseDetail/'+id,
          b = 'learn',
          c = '培训课程',
          aa = encodeURIComponent(encodeURIComponent(a)),
          bb = encodeURIComponent(encodeURIComponent(b)),
          cc = encodeURIComponent(encodeURIComponent(c))
        return '/customer/action/proxy/redirect?dest='+ aa + '&pageName=' + bb + '&pageTitle=' + cc
      },
      //编码超链接地址
      getExamUrl(id) {
        var a ='/tjkStudy/examDetail/'+id,
          b = 'tjkStudyExam',
          c = '考试中心',
          aa = encodeURIComponent(encodeURIComponent(a)),
          bb = encodeURIComponent(encodeURIComponent(b)),
          cc = encodeURIComponent(encodeURIComponent(c))
        return '/customer/action/proxy/redirect?dest='+ aa + '&pageName=' + bb + '&pageTitle=' + cc
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ./src/page/examDetail.vue